export const titleLength = 70

export const descriptionLength = 160

export const urlLength = 76

export const portfolioWorkDescriptionLength = 500
